import script from "./ow-view-expenses.vue?vue&type=script&setup=true&lang=js"
export * from "./ow-view-expenses.vue?vue&type=script&setup=true&lang=js"

import "./ow-view-expenses.vue?vue&type=style&index=0&id=32657b28&lang=scss"

const __exports__ = script;

export default __exports__